<div class="behavior-graph-wrapper">
  <form [formGroup]="graphForm">
    <div class="header-wrapper">
      <h2 class="title">Time-of-Day Behavior Analysis</h2>
      <app-graph-filter
        (filterChange)="onFilterChange($event)"></app-graph-filter>
    </div>
    <nz-tabset
      [nzSelectedIndex]="selectedTabIndex"
      (nzSelectChange)="onTabChange($event)">
      <nz-tab nzTitle="Frequency">
        <app-frequency-datasheet-graph
          *ngIf="
            isGraphDataAvailable &&
              frequencyDatasheetGraphData &&
              value('datasheet') === 1 &&
              value('graph') === 1;
            else noDataTemplate
          "
          [graphData]="
            frequencyDatasheetGraphData
          "></app-frequency-datasheet-graph>
      </nz-tab>
      <nz-tab nzTitle="Frequency Interval">
        <app-frequency-interval-graph
          *ngIf="
            isGraphDataAvailable &&
              frequencyIntervalGraphData &&
              value('datasheet') === 1 &&
              value('graph') === 2;
            else noDataTemplate
          "
          [graphData]="
            frequencyIntervalGraphData
          "></app-frequency-interval-graph>
      </nz-tab>
      <nz-tab nzTitle="Latency">
        <app-latency-graph
          *ngIf="
            isGraphDataAvailable &&
              latencyGraphData &&
              value('datasheet') === 2;
            else noDataTemplate
          "
          [graphData]="latencyGraphData"></app-latency-graph>
      </nz-tab>
      <nz-tab nzTitle="Partial Interval">
        <app-partial-interval-graph
          *ngIf="
            isGraphDataAvailable &&
              partialIntervalGraphData &&
              value('datasheet') === 3;
            else noDataTemplate
          "
          [graphData]="partialIntervalGraphData"></app-partial-interval-graph>
      </nz-tab>
      <nz-tab nzTitle="Replacement Behaviors">
        <app-replacement-behavior-graph
          *ngIf="
            isGraphDataAvailable &&
              replacementGraphData &&
              value('datasheet') === 4;
            else noDataTemplate
          "
          [graphData]="replacementGraphData"></app-replacement-behavior-graph>
      </nz-tab>
    </nz-tabset>
    <ng-template #noDataTemplate>
      <div *ngIf="(loading$ | async) === false" class="no-graph-data">
        <h4 class="title s-18">No Data for Graph</h4>
      </div>
    </ng-template>
    <nz-divider></nz-divider>
  </form>
</div>
